import { render, staticRenderFns } from "./JoinTextPropertyEditor.vue?vue&type=template&id=1439eb42&scoped=true&"
import script from "./JoinTextPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./JoinTextPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1439eb42",
  null
  
)

export default component.exports